const thumbnailDay = require('@/assets/images/themes/Day-text.jpg')
const canvasDay = require('@/assets/images/themes/1280x720-Day.jpg')

const thumbnailDusk = require('@/assets/images/themes/Dusk-text.jpg')
const canvasDusk = require('@/assets/images/themes/1280x720-Dusk.jpg')

const thumbnailNight = require('@/assets/images/themes/Night-text.jpg')
const canvasNight = require('@/assets/images/themes/1280x720-Night.jpg')

const thumbnailSummer = require('@/assets/images/themes/Summer-text.jpg')
const canvasSummer = require('@/assets/images/themes/1280x720-Summer.jpg')

const thumbnailAutumn = require('@/assets/images/themes/Autumn-text.jpg')
const canvasAutumn = require('@/assets/images/themes/1280x720-Autumn.jpg')

const thumbnailNature = require('@/assets/images/themes/Nature-text.jpg')
const canvasNature = require('@/assets/images/themes/1280x720-Nature.jpg')

const thumbnailClassroom = require('@/assets/images/themes/Classroom-text.jpg')
const canvasClassroom = require('@/assets/images/themes/1280x720-Classroom.jpg')

const thumbnailShowtime = require('@/assets/images/themes/Showtime-text.jpg')
const canvasShowtime = require('@/assets/images/themes/1280x720-Showtime.jpg')

const thumbnailChristmas = require('@/assets/images/themes/Christmas-text.jpg')
const canvasChristmas = require('@/assets/images/themes/1280x720-Christmas.jpg')

const thumbnailFestival = require('@/assets/images/themes/Festival-text.jpg')
const canvasFestival = require('@/assets/images/themes/1280x720-Festival.jpg')

const thumbnailParty = require('@/assets/images/themes/Party-text.jpg')
const canvasParty = require('@/assets/images/themes/1280x720-Party.jpg')

const thumbnailMeeting = require('@/assets/images/themes/Meeting-text.jpg')
const canvasMeeting = require('@/assets/images/themes/1280x720-Meeting.jpg')

const thumbnailFuturism = require('@/assets/images/themes/Futurism-text.jpg')
const canvasFuturism = require('@/assets/images/themes/1280x720-Futurism.jpg')

const thumbnailBusiness = require('@/assets/images/themes/Business-text.jpg')
const canvasBusiness = require('@/assets/images/themes/1280x720-Business.jpg')

const thumbnailTechnology = require('@/assets/images/themes/Technology-text.jpg')
const canvasTechnology = require('@/assets/images/themes/1280x720-Technology.jpg')

export default {
  presentations: [
    {
      themeName: 'Day',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasDay,
        large: canvasDay,
        xLarge: canvasDay,
        name: 'themes/Day.jpg',
      },
      themeThumbnail: thumbnailDay,
      themeId: 1,
    },
    {
      themeName: 'Dusk',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 65,
      backgroundImage: {
        thumbnail: canvasDusk,
        large: canvasDusk,
        xLarge: canvasDusk,
        name: 'themes/Dusk.jpg',
      },
      themeThumbnail: thumbnailDusk,
      themeId: 2,
    },
    {
      themeName: 'Night',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasNight,
        large: canvasNight,
        xLarge: canvasNight,
        name: 'themes/Night.jpg',
      },
      themeThumbnail: thumbnailNight,
      themeId: 3,
    },
    {
      themeName: 'Summer',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasSummer,
        large: canvasSummer,
        xLarge: canvasSummer,
        name: 'themes/Summer.jpg',
      },
      themeThumbnail: thumbnailSummer,
      themeId: 4,
    },
    {
      themeName: 'Autumn',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasAutumn,
        large: canvasAutumn,
        xLarge: canvasAutumn,
        name: 'themes/Autumn.jpg',
      },
      themeThumbnail: thumbnailAutumn,
      themeId: 5,
    },
    {
      themeName: 'Nature',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasNature,
        large: canvasNature,
        xLarge: canvasNature,
        name: 'themes/Nature.jpg',
      },
      themeThumbnail: thumbnailNature,
      themeId: 6,
    },

    {
      themeName: 'Classroom',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 95,
      backgroundImage: {
        thumbnail: canvasClassroom,
        large: canvasClassroom,
        xLarge: canvasClassroom,
        name: 'themes/Classroom.jpg',
      },
      themeThumbnail: thumbnailClassroom,
      themeId: 7,
    },
    {
      themeName: 'Showtime',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 75,
      backgroundImage: {
        thumbnail: canvasShowtime,
        large: canvasShowtime,
        xLarge: canvasShowtime,
        name: 'themes/Showtime.jpg',
      },
      themeThumbnail: thumbnailShowtime,
      themeId: 8,
    },
    {
      themeName: 'Christmas',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasChristmas,
        large: canvasChristmas,
        xLarge: canvasChristmas,
        name: 'themes/Christmas.jpg',
      },
      themeThumbnail: thumbnailChristmas,
      themeId: 9,
    },

    {
      themeName: 'Festival',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasFestival,
        large: canvasFestival,
        xLarge: canvasFestival,
        name: 'themes/Festival.jpg',
      },
      themeThumbnail: thumbnailFestival,
      themeId: 10,
    },
    {
      themeName: 'Party',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasParty,
        large: canvasParty,
        xLarge: canvasParty,
        name: 'themes/Party.jpg',
      },
      themeThumbnail: thumbnailParty,
      themeId: 11,
    },
    {
      themeName: 'Meeting',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasMeeting,
        large: canvasMeeting,
        xLarge: canvasMeeting,
        name: 'themes/Meeting.jpg',
      },
      themeThumbnail: thumbnailMeeting,
      themeId: 12,
    },

    {
      themeName: 'Futurism',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasFuturism,
        large: canvasFuturism,
        xLarge: canvasFuturism,
        name: 'themes/Futurism.jpg',
      },
      themeThumbnail: thumbnailFuturism,
      themeId: 13,
    },
    {
      themeName: 'Business',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 77,
      backgroundImage: {
        thumbnail: canvasBusiness,
        large: canvasBusiness,
        xLarge: canvasBusiness,
        name: 'themes/Business.jpg',
      },
      themeThumbnail: thumbnailBusiness,
      themeId: 14,
    },
    {
      themeName: 'Technology',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 75,
      backgroundImage: {
        thumbnail: canvasTechnology,
        large: canvasTechnology,
        xLarge: canvasTechnology,
        name: 'themes/Technology.jpg',
      },
      themeThumbnail: thumbnailTechnology,
      themeId: 15,
    },
  ],
}
